module.exports = __webpack_public_path__ + "img/empty.17d62502.png";